import React, { Component, Fragment } from 'react'
import { Icon } from '@drifthq/tide-core'

import './style.css'

class PreviewInput extends Component {
  constructor(props) {
    super(props)
    this.state = {open: props.defaultOpen}
  }

  onClick = () => {
    this.setState({
      open: true
    })
  }

  render() {
    const {
      label,
      value,
      children,
    } = this.props

    const {
      open
    } = this.state
    
    if (open) {
      return (children)
    } else {
      return (
        <Fragment>
          <label className="previewinput-label">{label}</label>
          <div className="previewinput-container">
            {value}
            <div 
              onClick={this.onClick}
            >
              <Icon 
                name="edit-1"
                className="previewinput-click"
              />
            </div>
          </div>
        </Fragment> 
      )
    }
  }
}

export default PreviewInput


// WEBPACK FOOTER //
// ./src/components/PreviewInput/index.js